

import { Component, Input, OnInit, Injector, EventEmitter, Output } from '@angular/core';

import { MiscUtil } from '../../../util/misc.util';
import { DynformControl } from '../../../model/dymform-control';
import { UntypedFormGroup } from '@angular/forms';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";

import { BtDynamicFormControlComponent } from '../bt-dynamic-form-control/bt-dynamic-form-control.component' 


@Component({
    selector: 'bt-message-field',
    imports: [LibModulesWolcModule, BtDynamicFormControlComponent],
    templateUrl: './bt-message-field.component.html',
    styleUrl: './bt-message-field.component.scss'
})
export class BtMessageFieldComponent {
  bas = inject(BooktechAppService);


  @Input() form: UntypedFormGroup|null = null;
  @Input() control!: DynformControl;
  @Input() options:any = { };

  @Output() change = new EventEmitter<any>();

  constructor() {
    
  }

  fg():UntypedFormGroup {
    return (this.control.fg || this.form) as UntypedFormGroup;
  }

  ngOnInit(): void {
    // if(this.bas.envtest) console.log("BtMessageFieldComponent.ngOnInit, control: ", this.control);

    this.control.data.selectedLang = this.control.children[0]?.key;
    this.control.data.canEditHtml = this.bas.aas.isBn() && this.control.children[0]?.controlType == 'richtext'
  }

  onChange(event:any) {
    console.log("BtMessageFieldComponent.onChange, event: ", event);
    this.change.emit(event);
    
  }

  onTabChange(event:any) {
    console.log("BtMessageFieldComponent.onTabChange, event: ", event);

    let child = this.control.children[event];
    this.control.data.selectedLang = child.key;
  }
    
  onHtmlChange(editHtmlEnabled:boolean) {
    let ctrl = this.control;

    for (let c of ctrl.children) {
      c.controlType = !editHtmlEnabled ? "richtext" : "textarea";
    }
    // this.apps.bas.fs.updateControls(this.edit.form, this.edit.controls);
  }


}


